<div id="list-insurance" *ngIf="templateView==1">
    <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.SEND_DOCUMENTS_POLICY2" | translate }}</h2>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="row mx-3">
                <div class="col-md-12 my-5">
                    <span class="font-weight-boldest font-size-h6 text-dark-50">{{ "MENU.H4FILTER" | translate}}</span>
                </div>
            </div>
            <div class="form-group row mx-3 justify-content-md-left">
                <div class="col-md-12">
                    <form
                    [formGroup]="filterPolicyForm"
                    (ngSubmit)="submitFilterPolicy(loadingModal)"
                    >
                        <div class="row mb-3">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INPUT.BY_POLICY_NUM" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.BY_POLICY_NUM' | translate }}" formControlName="inputNroDePoliza" name="inputNroDePoliza">
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="sr-only">{{ "INPUT.YEAR" | translate }}</label>
                                            <select class="form-control" placeholder="" formControlName="inputAnyo" name="inpuAnyo">
                                                <option value="">{{ "INPUT.YEAR" | translate }}</option>
                                                <option *ngFor="let item of anyos | async" value="{{item.IdAno}}">{{item.Ano}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="sr-only">{{ "INPUT.MONTH" | translate }}</label>
                                            <select class="form-control" placeholder="" formControlName="inputMes" name="inputMes">
                                                <option value="">{{ "INPUT.MONTH" | translate }}</option>
                                                <option *ngFor="let item of meses | async" value="{{item.Mes}}">{{item.Descripcion}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INSURANCE.CATEGORY" | translate }}</label>
                                    <select class="form-control" placeholder="" formControlName="inputRamo" name="inputRamo" (change)="changeRamo($event)">
                                        <option value="">{{ "INSURANCE.CATEGORY" | translate }}</option>
                                        <option *ngFor="let item of ramos | async" value="{{item.IdRamo}}">{{item.Ramo}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INSURANCE.SUB_CATEGORY" | translate }}</label>
                                    <select class="form-control" formControlName="inputSubRamo" name="inputSubRamo" ng-disabled="!IdRamo">
                                        <option value="">{{ "INSURANCE.SUB_CATEGORY" | translate }}</option>
                                        <option *ngFor="let item of subramos | async" value="{{item.IdSubRamo}}">{{item.SubRamo}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INPUT.FIRSTNAME" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.FIRSTNAME' | translate }}" formControlName="inputAsegurado" name="inputAsegurado">
                                </div>
                            </div>

                            <!--div class="col-md-2">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INPUT.PERSONID" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.PERSONID' | translate }}" formControlName="inputIdentificacion" name="inputIdentificacion">
                                </div>
                            </div -->

                            <div class="col-md-2" *ngIf="config.IdMostrarTablilla==1">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INPUT.CARID" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.CARID' | translate }}" formControlName="inputPlaca" name="inputPlaca">
                                </div>
                            </div>

                            <div class="col-md-2" *ngIf="permissionMenu.VerGrupoEconomico == 1">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INPUT.ECONOMICGROUP" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.ECONOMICGROUP' | translate }}" formControlName="inputGrupoEconomico" name="inputGrupoEconomico">
                                </div>
                            </div>

                            <div class="col-md-3" *ngIf="permissionMenu.VerCompania == 1">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INPUT.COMPANIES" | translate }}</label>
                                    <select class="form-control" placeholder="" formControlName="inputIdCompania" name="inputIdCompania">
                                        <option value="">{{ "INPUT.COMPANIES" | translate }}</option>
                                        <option *ngFor="let item of companies | async" value="{{item.IdCompania}}">{{item.Compania}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group mb-0">
                                    <button [disabled]="activeSubmitFilterPolicy" type="submit" class="btn btn bg-success text-white font-weight-boldest  mr-2" >{{ "INPUT.FILTER" | translate }}</button>
                                    <button type="reset" class="btn btn-default text-dark-50 font-weight-boldest ">{{ "INPUT.RESET" | translate }}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>


	<ng-container *ngIf="submitState == submitStates.HasEmpty">
		<div class="my-5 alert alert-custom alert-light-danger alert-dismissible">
			<div class="alert-text">{{ "INPUT.EMPTY_SELECTED_POLICIES" | translate }}</div>
		</div>
	</ng-container>

    <div class="card card-custom gutter-b my-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "GENERAL.LISTING_INSURANCE" | translate }}</h3>
            </div>
        </div>
        
        <div class="card-body py-0 px-0">
            <div class="table-responsive angular-bootstrap-table">
                <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                    <thead style="background-color: rgb(130,124,120);color:white;">
                        <th width="20%" class="text-light">
                            {{ "INSURANCE.INSURED" | translate }}
                        </th>
                        <th class="text-light">
                            {{ "INSURANCE.SUB_CATEGORY" | translate }}
                        </th>
                        <th>
                            {{ "INSURANCE.NUM_POLICY" | translate }}
                        </th>
                        <th>
                            {{ "INPUT.EMAIL" | translate }}
                        </th>
                        <th width="5%">
                            {{ "INSURANCE.START_DATE" | translate }}
                        </th>
                        <th width="5%">
                            {{ "INSURANCE.DUE_DATE" | translate }}
                        </th>
                        <th *ngIf="showComapnyName">
                            {{ "INSURANCE.COMPANY" | translate }}
                        </th>
                        <th>{{"INSURANCE.STATUS" | translate }}</th>
                        <th class="text-center">{{ "INPUT.SELECT" | translate }}</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let policy of insuranceService.items$ | async; let i = index">
                            <td>{{ policy.Asegurado }}</td>
                            <td>{{ policy.SubRamo }}</td>
                            <td>{{ policy.NroDePoliza }}</td>
                            <td>{{ policy.Email }}</td>
                            <td>{{ policy.VigenciaDesde | date: 'MM/dd/yyyy' }}</td>
                            <td>{{ policy.VigenciaHasta | date: 'MM/dd/yyyy' }}</td>
                            <td *ngIf="showComapnyName"></td>
                            <td >{{ policy.Estatus }}</td>
                            <td class="text-center">
								<input type="checkbox" id="idPolicy{{i}}" name="idPolicy{{i}}" value="{{policy.IdPoliza}}" data-email="a@a.com" />
                            </td>
                        </tr>

                        <tr *ngIf="!(insuranceService.items$ | async)?.length">
                            <td colspan="8">
                                <p class="my-5"><strong>{{ "GENERAL.EMPTY_QUERY" | translate }}</strong></p>
                            </td>
                        </tr>
                    </tbody>
					<tfoot *ngIf="(insuranceService.items$ | async)?.length">
						<tr >
                            <td colspan="8" class="text-right">
								<button class="btn btn-success" (click)="processPolicies(processPoliciesModal)">{{ "INPUT.PROCESS_SELECTION" | translate}}</button>
                            </td>
                        </tr>
					</tfoot>
                </table>
            </div>
            <!--
            <app-paginator class="d-flex justify-content-between align-items-center flex-wrap" [paginator]="paginator"
                [isLoading]="isLoading" (paginate)="paginate($event)"></app-paginator>-->
        </div>
    </div>
</div>


<div class="loadingModal">
    <ng-template #loadingModal let-c="close" let-d="dismiss">
        <div class="modal-body">
            <div class="loading-totalesModal">
                <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
            </div>
        </div>
    </ng-template>
</div>


<div class="processPoliciesModal">
    <ng-template #processPoliciesModal let-c="close" let-d="dismiss">
		<div class="modal-header">
            <h4 class="modal-title">{{ "INPUT.PROCESS_POLICIE_SELECTION" | translate}}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
		<form
		   class=""
			[formGroup]="sendDocumentForm"
			(ngSubmit)="submitSendDocument(loadingModal)"
		   >
			<div class="modal-body">
                <p><strong>{{ "INPUT.SEND_POLICIE_EMAIL" | translate }}</strong></p>

				<!-- begin::Alert error-->
				<ng-container *ngIf="submitState == submitStates.HasError">
					<div class="mb-10 alert alert-custom alert-light-danger alert-dismissible">
						<div class="alert-text">{{ "INPUT.ERROR_REQUIRED" | translate }}</div>
					</div>
				</ng-container>

				<ng-container *ngIf="submitState == submitStates.CodeError">
					<div class="mb-10 alert alert-custom alert-light-danger alert-dismissible">
						<div class="alert-text">{{ "INPUT.ERROR_SEND_POLICIES" | translate }}</div>
					</div>
				</ng-container>
				<!-- end::Alert error-->
			
				<div class="form-group d-none">
						<label for="inputEmail">{{ "INPUT.EMAIL" | translate}}</label>
						<input type="email" id="inputEmail" name="inputEmail" formControlName="inputEmail" class="form-control" autocomplete="off"
						>
						<ng-container
						[ngTemplateOutlet]="formError"
						[ngTemplateOutletContext]="{
						validation: '',
						message: 'Campo requerido.',
						control: sendDocumentForm.controls['inputEmail']
						}"
					></ng-container>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default text-dark" (click)="c('Close click')">{{ "INPUT.CANCEL" | translate}}</button>
				<button type="submit" class="btn btn-success">{{ "INPUT.SEND" | translate }}</button>
			</div>
		</form>
    </ng-template>
</div>


<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        {{ message }}
      </div>
    </div>
  </ng-container>
</ng-template>